import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

import {
  AdminUpdateUserRequest,
  BusinessAdminUserResponse,
  SimplePageResponse
} from '../models/business-admin-user.model';

@Injectable({ providedIn: 'root' })
export class BusinessAdminAuthService {

  private readonly apiUrl = `${environment.apiUrl}api/auth`;

  constructor(private http: HttpClient) {}

  updateAdminUser(userId: number, request: AdminUpdateUserRequest): Observable<BusinessAdminUserResponse> {
    return this.http.put<BusinessAdminUserResponse>(`${this.apiUrl}/admin/users/${userId}`, request);
  }

  searchBusinessAdmins(params: {
    businessId: number;
    roleId?: number;
    isActive?: boolean;
    page?: number;
    size?: number;
  }): Observable<SimplePageResponse<BusinessAdminUserResponse>> {

    let httpParams = new HttpParams().set('businessId', String(params.businessId));

    if (params.roleId !== undefined) httpParams = httpParams.set('roleId', String(params.roleId));
    if (params.isActive !== undefined) httpParams = httpParams.set('isActive', String(params.isActive));

    httpParams = httpParams
      .set('page', String(params.page ?? 0))
      .set('size', String(params.size ?? 20));

    return this.http.get<SimplePageResponse<BusinessAdminUserResponse>>(
      `${this.apiUrl}/users/search`,
      { params: httpParams }
    );
  }
}
